import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const Users = forwardRef<Ref, IconPropsType>(({ color = "currentColor", size, ...rest }, ref) => {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.75 6.75C10.75 8.82107 9.07107 10.5 7 10.5C4.92893 10.5 3.25 8.82107 3.25 6.75C3.25 4.67893 4.92893 3 7 3C9.07107 3 10.75 4.67893 10.75 6.75Z"
        fill={color}
      />
      <path
        d="M17 10.5C19.0711 10.5 20.75 8.82107 20.75 6.75C20.75 4.67893 19.0711 3 17 3C14.9289 3 13.25 4.67893 13.25 6.75C13.25 8.82107 14.9289 10.5 17 10.5Z"
        fill={color}
      />
      <path
        d="M15.4649 20C15.8052 19.4117 16 18.7286 16 18V16.1668C16 15.3309 15.7391 14.4103 15.0823 13.6619C14.7324 13.2632 14.3532 12.8904 13.948 12.547C14.8983 12.1933 15.9266 12 17 12C19.6224 12 21.9754 13.1536 23.5791 14.9811C23.8649 15.3068 24 15.7334 24 16.1668V18C24 19.1046 23.1046 20 22 20H15.4649Z"
        fill={color}
      />
      <path
        d="M13.9594 18.4031C13.7729 19.3144 12.9665 20 12 20H2C0.895431 20 0 19.1046 0 18V16.1668C0 15.7334 0.135096 15.3068 0.420908 14.9811C2.02461 13.1536 4.37758 12 7 12C8.85906 12 10.5827 12.5798 12 13.5684C12.582 13.9743 13.1123 14.4492 13.5791 14.9811C13.8649 15.3068 14 15.7334 14 16.1668V18C14 18.1381 13.986 18.2729 13.9594 18.4031Z"
        fill={color}
      />
    </svg>
  );
});
export default Users;
